import React, { useEffect} from 'react';
import DashUser from '../../DashUser/DashUser';
import useAppState from '../../DashUser/useAppState';

const ClientPreview = (props) => {
  const { state, actions } = useAppState();
  
  let userRequested = props.match.params.id

  let fetchData = async () => {
    
    let userLogged = await localStorage.getItem('user') ? JSON.parse(await localStorage.getItem('user')) : props.state; 
    let tokenUserLogged = userLogged.token
    let userId =  props.adminPetition ? props.adminPetition.id : userLogged._id;
    
    await actions.getRegistersData(props.match.params.id, tokenUserLogged)
  }

  useEffect(() => {
    fetchData();
  },['props']);

  return (
    <div style={{backgroundColor: "#F4FCFB", padding: "25px"}}>
      {!state.data ? <div>Cargando...</div>: <DashUser adminPetition={props.match.params} state={state} actions={actions} userRequested={userRequested}/>}
      
    </div>
  );
}

export default ClientPreview;
